import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import { UserRole } from "../../../@types/userRole";
import axiosInstance from "../../../utils/axiosConfig";
export const createUserRole = createAsyncThunk(
  "locationShow/createUserRole",
  async (idUser: string, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { data } = await axiosInstance.post(`${api.baseURL}userrole`, {
        user: idUser,
        location: state.locationShow.location.id,
        periodStart: new Date().getTime(),
      });
      return data as UserRole;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
